
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...urlPaths]",
      function () {
        return require("private-next-pages/[...urlPaths].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...urlPaths]"])
      });
    }
  